// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-use-before-define */
import {get} from 'lodash';

import {Client, checkAccountType, formatClientAccount} from '@advisor/models/store/client/index';
import ClientOnboarding from '@advisor/models/store/client/clientOnboarding';
// eslint-disable-next-line import/no-cycle
import AdvisorProxyApi from '@advisor/advisorProxyApi';
import RwClientService from '@advisor/rwSdk/ClientService';
import RwPerformanceReturnService from '@advisor/rwSdk/PerformanceReturnService';
import RwRiskToleranceService from '@advisor/rwSdk/RiskToleranceService';
import RwCustodianService from '@advisor/rwSdk/CustodianService';
import RwOrchestrateService from '@advisor/rwSdk/OrchestrateService';
import AdvisorService from '@advisor/rwSdk/AdvisorService';
import {returnNoneApi} from '@advisor/util/returnNoneApi';
import PII from '@advisor/util/PII';
import {NOTIFICATION_TYPE, USER_TYPE} from '@advisor/util/constants';
import exceptionHandler from '@advisor/util/exceptionHandler';
import ClientService from '@advisor/services/Client';
import CloudConvertServices from '@advisor/rwSdk/CloudConvertService';
import RwAuthService from '@advisor/rwSdk/AuthService';
// eslint-disable-next-line import/no-cycle
import {addRiaComponentTo} from '@advisor/util/store/paramInjects';
import {uploadDocumentFlag} from '@advisor/remote-config';
import {mapDocumentResponse} from '@advisor/util/documentResponseMapper';

const handledResponses = new Set([409]);

const stateObj = function () {
  return new Client();
};
const getters = {
  // eslint-disable-next-line consistent-return
  clientsByFilter: (state) => (select, riaUserId) => {
    if (select === '') return [];

    if (select === 'ALL_CLIENTS') return state.clients;

    if (select === 'MY_CLIENTS') return state.clients.filter((c) => c.riaUserId === riaUserId);

    if (select === 'MY_AND_SHARED_CLIENTS')
      return state.clients.filter((c) => c.riaUserId === riaUserId || c.riaUserIdBackup === riaUserId);
  },
  clientFilterableColumns: (state) => {
    // eslint-disable-next-line no-use-before-define
    return state.clients.map((element) => getColumns(element));

    // eslint-disable-next-line func-style
    function getColumns(item, index = 0) {
      // eslint-disable-next-line no-use-before-define
      const calcLoginAtempts = loginAttempts(item);

      return {
        id: item.id,
        index,
        calcClient: `${item.firstName} ${item.lastName}`,
        totalAum: item.totalAum ? item.totalAum : 0,
        totalAutomatedAum: item.totalAutomatedAum ? item.totalAutomatedAum : 0,
        numberOfAccounts: item.numberOfAccounts || 0,
        calcLoginAtempts,
        email1:
          // eslint-disable-next-line no-use-before-define
          hasProperty(item, 'contactInfo.email1', false) && item.contactInfo.email1 !== null ? item.contactInfo.email1 : '',
        // eslint-disable-next-line no-negated-condition
        riaUserName: item.riaUserName.trim() !== 'null null' ? item.riaUserName : '-',
        segmentName: item.segment ? item.segment.label : '-',
      };
    }

    // eslint-disable-next-line func-style
    function hasProperty(obj, path) {
      return !!get(obj, path, false);
    }

    // eslint-disable-next-line func-style
    function loginAttempts(client) {
      // eslint-disable-next-line no-nested-ternary
      return hasProperty(client, 'loginAudit.successfulLoginAtempts')
        ? // eslint-disable-next-line no-negated-condition
          client.loginAudit.successfulLoginAtempts !== null
          ? client.loginAudit.successfulLoginAtempts
          : 0
        : 0;
    }
  },
  clientSortingColumns: (state) => {
    // eslint-disable-next-line no-use-before-define
    return state.clients.map((element) => getColumns(element));

    // eslint-disable-next-line func-style
    function getColumns(item, index = 0) {
      return {
        id: item.id,
        index,
        CLIENT_FIRST_NAME: `${item.firstName} ${item.lastName}`,
        TOTAL_AUM: item.totalAum ? item.totalAum : 0,
        TOTAL_AUTOMATED_AUM: item.totalAutomatedAum ? item.totalAutomatedAum : 0,
        NO_OF_ACCOUNTS: item.numberOfAccounts || 0,
        CLIENT_EMAIL:
          // eslint-disable-next-line no-use-before-define
          hasProperty(item, 'contactInfo.email1', false) && item.contactInfo.email1 !== null ? item.contactInfo.email1 : '',
        // eslint-disable-next-line no-negated-condition
        RIA_USER_FIRST_NAME: item.riaUserName.trim() !== 'null null' ? item.riaUserName : '-',
        SEGMENT_LABEL: item.segment ? item.segment.label : '-',
        INVESTMENT_MODEL_TYPE: item.investmentModel,
      };
    }

    // eslint-disable-next-line func-style
    function hasProperty(obj, path) {
      return !!get(obj, path, false);
    }
  },
  houseHoldFilterableColumns: (state) => {
    // eslint-disable-next-line no-use-before-define
    return state.allHouseholds.map((element) => getColumns(element));

    // eslint-disable-next-line func-style, no-unused-vars
    function getColumns(item) {
      return {
        index: item.houseHoldId,
        Households: item.houseHoldName ? item.houseHoldName : 'no',
        // eslint-disable-next-line no-negated-condition
        AUM: item.aum !== null ? item.aum : 0,
        // eslint-disable-next-line no-negated-condition
        Cash: item.cash !== null ? item.cash : 0,
        // eslint-disable-next-line no-negated-condition
        Automated_Assets: item.automatedAssets !== null ? item.automatedAssets : 0,
        // eslint-disable-next-line no-negated-condition
        numberOfAutomatedAccounts: item.numberOfAutomatedAccounts !== null ? item.numberOfAutomatedAccounts : 0,
        // eslint-disable-next-line no-negated-condition
        Members: item.totalMembers !== null ? item.totalMembers : 0,
        // eslint-disable-next-line no-negated-condition
        IARs: item.totalAdvisors !== null ? item.totalAdvisors : 0,
      };
    }
  },
  clientsByNames: (state) => {
    // eslint-disable-next-line no-use-before-define
    return state.clients.map((element) => getFullName(element));

    // eslint-disable-next-line func-style, no-unused-vars
    function getFullName(item) {
      return {
        value: item.contactInfo.email1,
        label: `${item.firstName} ${item.lastName}`,
      };
    }
  },
  householdsByNames: (state) => {
    // eslint-disable-next-line no-use-before-define
    return state.allHouseholds.map((element) => getFullName(element));

    // eslint-disable-next-line func-style, no-unused-vars
    function getFullName(item) {
      return {
        value:
          // eslint-disable-next-line no-use-before-define
          hasProperty(item, 'contactInfo.email1', false) && item.contactInfo.email1 === null ? item.contactInfo.email1 : '',
        label: `${item.firstName} ${item.lastName}`,
      };
    }

    // eslint-disable-next-line func-style
    function hasProperty(obj, path) {
      return !!get(obj, path, false);
    }
  },
  totalsByAdvisor: (state) => [
    {text: 'Clients', qty: state.clients.length},
    {text: 'Households', qty: state.allHouseholds.length},
  ],
  // client details
  documentFilterableColumns: (state) => {
    // eslint-disable-next-line no-use-before-define
    return state.clientDocuments.map((element) => getColumns(element));

    // eslint-disable-next-line func-style, no-unused-vars
    function getColumns(item) {
      return {
        doc_id: item.doc_id,
        // eslint-disable-next-line no-use-before-define
        file_icon: icon(item.mime_type),
        file_name: item.file_name,
        file_id: item.file_id,
        mime_type: item.mime_type,
        file_description: item.file_description,
        folder_name: item.folder_name,
        upload_date: item.upload_date,
        uploaded_by: item.uploaded_by,
        // REFACTOR: actions should depend of client type conditions
        docActions: 'p,d,r',
      };
    }

    // eslint-disable-next-line func-style
    function icon(type) {
      // REFACTOR: return font awesome file type here instead of MD icon name
      if (type === 'application/pdf') {
        return 'picture_as_pdf';
        // eslint-disable-next-line no-else-return
      } else {
        return 'file_copy';
      }
    }
  },
  // client profile - investment advisor details
  investmentAdvisorDetails: (state) => ({
    id: state.clientDetails.id,
    riaUserName: state.clientDetails.riaUserName,
    backupRiaUserName: state.clientDetails.backupRiaUserName,
  }),
  // Client details performance - Client Account
  clientAccounts: (state) => {
    if (state.clientDetails.clientAccounts) {
      const relevantAccounts = state.clientDetails.clientAccounts
        .filter((element) => checkAccountType(element))
        .map((element) => formatClientAccount(element));

      // If relevant account not available, show one item in dropdown with No Data message
      if (relevantAccounts && relevantAccounts.length === 0) {
        return [{id: null, name: 'No Accounts', custodianId: null}];
      }

      return [...relevantAccounts];
    }

    return [{id: null, name: 'No Accounts', custodianId: null}];
  },
  accountSummary: (state) => state.clientDetails.accountDetail.summary,
  tempRepCode: (state) => state.client.tempRepCode,
  tempCustodianId: (state) => state.client.tempCustodianId,
};

const actions = {
  async getTopClients({commit}, payload) {
    try {
      const result = await RwClientService.getClUsersList(payload).catch((error) => {
        throw error;
      });
      const data = result?.data;

      return commit('SET_TOP_CLIENTS', data);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getTopClients', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line consistent-return
  async getClients({commit}, payload) {
    try {
      const result = await RwClientService.getClUsersList(payload).catch((error) => {
        throw error;
      });

      const data = result;

      commit('SET_CLIENTS', data);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClients', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line consistent-return
  async getClientsSummary({commit}, payload) {
    try {
      const data = await AdvisorService.getRiaUserOverview(payload).catch((error) => {
        throw error;
      });

      commit('SET_CLIENTS_SUMMARY', data);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientsSummary', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line consistent-return
  async getSearchBarClients({commit}, payload) {
    try {
      let apiResponse = {};

      if (payload.offset === 0) {
        commit('RESET_SEARCHBAR_CLIENTS', []);
      }

      const include = payload.isAccountsIncluded ? `ACCOUNTS` : ``;
      const {riaUserId, offset, limit, searchValue} = payload;
      const options = {
        riaUserId: Number(riaUserId),
        offset,
        limit,
        searchValue,
        include,
      };

      const response = await RwClientService.searchClient(options).catch((error) => {
        throw error;
      });

      apiResponse = {data: response};

      commit('SET_SEARCH_CLIENT_PAGINATION', apiResponse.data);

      commit('SET_SEARCHBAR_CLIENTS', apiResponse.data.data);

      return Promise.resolve(apiResponse.data);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getSearchBarClients', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resetClientList({commit}, payload) {
    commit('RESET_SEARCHBAR_CLIENTS', []);
  },
  // eslint-disable-next-line consistent-return
  async getHouseholds({commit}, payload) {
    try {
      const apiCall = await AdvisorProxyApi.getHouseholdsList(payload);

      returnNoneApi(apiCall);
      commit('SET_HOUSEHOLDS', apiCall.data.data);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getHouseholds', error);

      return Promise.reject(error);
    }
  },
  async getClientWithSubResources({commit}, payload) {
    try {
      const sdkResponse = await RwClientService.getClientWithSubResources(payload).catch((error) => {
        throw error;
      });

      commit('SET_CLIENT_DETAILS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientWithSubResources', error);

      return Promise.reject(error);
    }
  },
  async getClientHouseholdGoals({commit}, payload) {
    try {
      const sdkResponse = await RwClientService.getClientHouseholdGoals(payload).catch((error) => {
        throw error;
      });

      commit('SET_CLIENT_HOUSEHOLD_GOALS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientHouseholdGoals', error);

      return Promise.reject(error);
    }
  },
  /**
   *
   * @param {Object} context
   * @param {Object<Number, Array<String>>} piiProps
   */
  async getClientPII({rootState}, {id, piiProps}) {
    try {
      const fullPayload = addRiaComponentTo({id, piiProps}, rootState.settings.default);

      const sdkResponse = await RwClientService.getClientWithSubResources(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientPII', error);

      return Promise.reject(error);
    }
  },
  async getClientSpecificInfo(_, payload) {
    try {
      const response = await RwClientService.getClUserDetails({
        clUserId: payload.id,
      });

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientSpecificInfo', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line no-unused-vars, consistent-return
  async deleteDocument(_, payload) {
    try {
      const {riaId, clientId: clUserId, docId: docIdList} = payload;
      const options = {riaId, clUserId, docIdList};
      const response = await RwClientService.deleteDocument(options);

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.deleteDocument', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line no-unused-vars, consistent-return
  async deleteAccountRequest({rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);
      const sdkResponse = await RwClientService.deleteClientAccountRequest(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.deleteAccountRequest', error);

      return Promise.reject(error);
    }
  },
  /**
   * Get performance Summary data for given account ids, client id and selected begin date and end date
   */
  async getPerformanceSummaryData(_, payload) {
    try {
      const response = await RwPerformanceReturnService.postPerformanceSummary(payload);

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getPerformanceSummaryData', error);

      return Promise.reject(error);
    }
  },
  async downloadDocument(_, payload) {
    try {
      const response = await RwClientService.downloadDocumentByDocId(payload);

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.downloadDocument', error);

      return Promise.reject(error);
    }
  },
  async advDocUpload(_, payload) {
    try {
      const {base64File, clientId: clUserId, description, fileName, folder, mimetype} = payload;

      const options = {
        base64File,
        clUserId,
        description,
        fileName,
        folder,
        mimetype,
      };

      let response;
      // depending on feature flag status, the respective service will be called

      if (await uploadDocumentFlag()) {
        response = await CloudConvertServices.scanAndUploadDocument(options).catch((error) => {
          throw error;
        });
        const mappedResponse = mapDocumentResponse(response.fileInfo);

        return Promise.resolve(mappedResponse);
      }

      response = await RwClientService.uploadDocumentByBase64(options).catch((error) => {
        throw error;
      });

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.advDocUpload', error);
      throw error;
    }
  },
  async getClientDocuments({commit}, payload) {
    try {
      const {clientId} = payload;
      const clUserId = clientId.toString();
      const response = await RwClientService.getDocumentSummary({
        clUserId,
      }).catch((error) => {
        throw error;
      });

      return commit('SET_CLIENT_DOCUMENTS', response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientDocuments', error);

      return Promise.reject(error);
    }
  },
  async createClient({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo({user: payload}, rootState.settings.default);

      const sdkResponse = await RwClientService.createUpdateClient(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_CLIENT_DETAILS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.createClient', error);

      return Promise.reject(error);
    }
  },
  async updateClientDetails({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo({clUser: payload}, rootState.settings.default);

      const sdkResponse = await RwClientService.updateClient(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_CLIENT_DETAILS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.updateClientDetails', error);

      return Promise.reject(error);
    }
  },
  async updateClientAdvisor({commit, dispatch}, payload) {
    try {
      const response = await dispatch('client/updateClientDetails', payload, {
        root: true,
      });

      commit('SET_CLIENT_ADVISOR', payload);

      return response;
    } catch (error) {
      exceptionHandler.handleGenericException('client.updateClientAdvisor', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line consistent-return
  async changeClientAccess({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo({clUser: payload}, rootState.settings.default);

      const sdkResponse = await RwClientService.updateClient(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_CLIENT_ACCESS', payload.dashboardAccess);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.changeClientAccess', error);

      return Promise.reject(error);
    }
  },
  async getClientFullSsn({rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo({clUserId: payload.clientId}, rootState.settings.default);

      const sdkResponse = await RwClientService.getClUserSSN(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientFullSsn', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line require-await
  async setClientOnBoardingData({commit}, payload) {
    commit('SET_CLIENT_ONBOARDING', payload);
  },
  // eslint-disable-next-line consistent-return
  async sendClientRegistrationMail({rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);
      const sdkResponse = await RwOrchestrateService.sendClientRegistrationMail(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.sendClientRegistrationMail', error);

      return Promise.reject(error);
    }
  },
  // requires email and riaId to be in payload mandetorily
  async checkEmailAvailability({rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo({...payload, userType: USER_TYPE.RIA_USER}, rootState.settings.default);
      const sdkResponse = await RwAuthService.isEmailAvailable(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve({available: sdkResponse});
    } catch (error) {
      exceptionHandler.handleGenericException('client.checkEmailAvailability', error);

      return Promise.reject(error);
    }
  },
  async getWorkflowDocuments(_, payload) {
    try {
      const objResponse = await AdvisorProxyApi.getWorkflowDocuments(payload);

      returnNoneApi(objResponse);

      return objResponse.data;
    } catch (error) {
      exceptionHandler.handleGenericException('client.getWorkflowDocuments', error);

      return Promise.reject(error);
    }
  },
  async getAccountTypeList({commit}, payload) {
    try {
      const objResponse = await AdvisorProxyApi.getAccountTypeList(payload);

      returnNoneApi(objResponse);

      commit('SET_ACCOUNT_TYPES', objResponse.data.data);

      return objResponse.data.data;
    } catch (error) {
      exceptionHandler.handleGenericException('client.getAccountTypeList', error);

      return Promise.reject(error);
    }
  },
  async getGoalList({commit}, payload) {
    try {
      const response = await RwClientService.getGoalList(payload);

      commit('SET_GOALS_LIST', response);

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getGoalList', error);

      return Promise.reject(error);
    }
  },
  /**
   * This API updates the properties of custodian account
   * @param {} param0
   * @param {clUserId, custId, repCode} payload
   */
  async getOrUpdateCustodianAccount({dispatch}, payload) {
    try {
      const response = await RwCustodianService.addAccount({
        requestBody: payload,
      }).catch((error) => {
        const {microserviceStatusCode} = error;

        // eslint-disable-next-line no-param-reassign
        error.response = {status: microserviceStatusCode};
        throw error;
      });

      return Promise.resolve(response);
    } catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 404) {
        dispatch(
          'notification/setMessage',
          {
            type: NOTIFICATION_TYPE.ERROR,
            text: 'Your client request contains inconsistencies. Please try again.',
            timeout: 5,
          },
          {root: true}
        );
      }

      exceptionHandler.handleGenericException('client.getOrUpdateCustodianAccount', error);

      return Promise.reject(error);
    }
  },
  /**
   * This API associates segment goal with client account
   * MS responds with 409: (conflict) if the goal is already present so this responds with resourceId as goalId
   * @param {} param0
   * @param {clUserId, segmentGoalId, retirementAge?, targetGoalDate?, prevSelectedGoalId?} payload
   */
  async associateGoalWithClient({dispatch}, payload) {
    try {
      const {prevSelectedGoalId} = payload;

      // eslint-disable-next-line no-param-reassign
      delete payload.prevSelectedGoalId;

      const sdkResponse = await RwClientService.addClientGoals(payload).catch((error) => {
        const {microserviceStatusCode, microserviceResourceId} = error;

        // eslint-disable-next-line no-negated-condition
        if (microserviceStatusCode !== 409 && prevSelectedGoalId) {
          dispatch(
            'client/disassociateGoalWithClient',
            {
              goalId: prevSelectedGoalId,
            },
            {root: true}
          );
        } else {
          const data = {resourceId: microserviceResourceId};

          // eslint-disable-next-line no-param-reassign
          error.response = {status: microserviceStatusCode, data};
          throw error;
        }
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      if (error.response.status === 409) {
        await dispatch(
          'client/updateClientGoal',
          {
            goalId: error.response.data.resourceId,
            retirementAge: payload.retirementAge,
            targetDate: payload.targetGoalDate,
          },
          {root: true}
        );

        return {
          goalId: error.response.data.resourceId,
        };
        // eslint-disable-next-line no-else-return
      } else {
        exceptionHandler.handleGenericException('client.associateGoalWithClient', error);

        return Promise.reject(error);
      }
    }
  },
  /**
   * This deletes the goal which is not associated with any of account of that client
   * @param {} param0
   * @param {goalId} payload
   */
  async disassociateGoalWithClient(_, payload) {
    try {
      const objResponse = await AdvisorProxyApi.disassociateGoalWithClient(payload);

      returnNoneApi(objResponse);

      return objResponse.data.data;
    } catch (error) {
      exceptionHandler.handleGenericException('client.disassociateGoalWithClient', error);

      return Promise.reject(error);
    }
  },
  /**
   * This returns with active requestId if any
   * @param {*} param0
   * @param {clUserId, custodianId, requestInitiatedFrom} payload
   */
  async getActiveAccountRequests(_, payload) {
    try {
      const response = await RwClientService.getUnFinishedClientAccounts(payload).catch((error) => {
        throw error;
      });

      return Promise.resolve({data: {data: response}});
    } catch (error) {
      exceptionHandler.handleGenericException('client.getActiveAccountRequests', error);

      return Promise.reject(error);
    }
  },
  /**
   * Get performance report data for given account ids, for given client
   * @param {*} param0
   * @param {accountIds} payload
   */
  async getPerformanceReport(_, payload) {
    try {
      const {accountIds, beginDate, clientId, endDate} = payload;
      const sdkPayload = {
        accountList: accountIds[0],
        beginDate,
        clientId,
        endDate,
      };

      const response = await RwPerformanceReturnService.getPerformanceTrendsByClientId(sdkPayload);

      const sdkResponse = {data: response};

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getPerformanceReport', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will fetch existing client onboarding data.
   * @param {Object} param0
   * @param {clUserId} payload
   */
  async fetchExistingClientOnboardingData({state}, payload) {
    if (!state.clientOnBoarding || !state.clientOnBoarding.id) {
      const objClientDetails = await this.dispatch('client/getClientWithSubResources', {
        id: payload.clUserId,
        subResources: 'goals,clientAccounts,clientAum,segment',
      });
      const {
        firstName,
        lastName,
        contactInfo,
        riaUserId,
        riaUserIdBackup,
        legalAddress,
        mailingAddress,
        dashboardAccess,
        riskTolerance,
      } = objClientDetails;

      try {
        this.dispatch('client/setClientOnBoardingData', {
          id: payload.clUserId,
          personalInfo: {
            firstName,
            lastName,
            riaUserId,
            riaUserIdBackup,
            legalAddress,
            mailingAddress,
            dashboardAccess,
            contactInfo: {
              ...contactInfo,
            },
            clientSettings: {
              openAccount: false,
              behavioralRiskTolerance: true,
              riskTolerance,
            },
          },
          designateBeneficiary: {
            maritalStatus: objClientDetails.maritalStatus,
            addBeneficiaries: false,
            addTrustedContact: false,
          },
        });
      } catch (error) {
        exceptionHandler.handleGenericException('client.fetchExistingClientOnboardingData', error);
      }
    }
  },
  /**
   * This will retun client goals
   * @param {*} param0
   * @param {clUserId} payload
   */
  async getClientGoals(_, payload) {
    try {
      const objResponse = await AdvisorProxyApi.getClientGoals(payload);

      returnNoneApi(objResponse);

      return objResponse.data;
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientGoals', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will update the client goal
   * @param {Object} param0 `Commit` for committing to store
   * @param {Object} payload `goalId` is mandetory
   */
  async updateClientGoal(_, payload) {
    try {
      const response = await RwClientService.updateGoal(payload).catch((error) => {
        throw error;
      });

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.updateClientGoal', error);

      return Promise.reject(error);
    }
  },
  /**
   * This will return all details goal of given goalId
   * @param {*} param0
   * @param {goalId} payload
   */
  async getClientGoal(_, payload) {
    try {
      const response = await RwClientService.getGoalByGoalId(payload).catch((error) => {
        throw error;
      });

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientGoal', error);

      return Promise.reject(error);
    }
  },
  /**
   * get client calender year performance
   * @param {*} commit
   * @param {object} payload {accountid,asOfDate}
   */
  async getClientCalenderYearPerformance(_, payload) {
    try {
      const {accountId, asOfDate} = payload;

      const options = {accountIds: [accountId], asOfDate};
      const response = await RwPerformanceReturnService.postTimebasedCalendarYearPerformance(options).catch((error) => {
        throw error;
      });

      return response;
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientCalenderYearPerformance', error);

      return Promise.reject(error);
    }
  },
  /**
   * get client calender year performance
   * @param {*} commit
   * @param {object} payload {accountid,asOfDate}
   */
  async getClientTrailingYearPerformance(_, payload) {
    try {
      const {accountId, asOfDate} = payload;
      const options = {accountIds: [accountId], asOfDate};
      const response = await RwPerformanceReturnService.postTimebasedTrailingYearPerformance(options).catch((error) => {
        throw error;
      });

      return response;
    } catch (error) {
      exceptionHandler.handleGenericException('client.getClientTrailingYearPerformance', error);

      return Promise.reject(error);
    }
  },
  async updateClientRoboStatus({rootState}, request) {
    try {
      const {clUserId, payload} = request;
      const clUser = {id: clUserId, roboStatus: payload.roboStatus};
      const fullPayload = addRiaComponentTo({clUser}, rootState.settings.default);

      const sdkResponse = await RwClientService.updateClientRoboStatus(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.updateClientRoboStatus', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line consistent-return
  async updateAccountRoboStatus({commit, dispatch}, payload) {
    try {
      const sdkResponse = await RwClientService.updateAccountDetails(payload.accPayload).catch((error) => {
        throw error;
      });

      dispatch('goal/updateRoboStatus', sdkResponse, {root: true});
      commit('SET_ACCOUNT_DETAILS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.updateAccountRoboStatus', error);
    }
  },
  // eslint-disable-next-line consistent-return
  async assignGoalToAccount(_, payload) {
    try {
      const sdkResponse = await RwClientService.updateAccountDetails(payload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      return exceptionHandler.handleGenericException('client.assignGoalToAccount', error, true);
    }
  },
  async getAccountDetails({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);
      const sdkResponse = await RwClientService.getAccountDetails(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_ACCOUNT_DETAIL_SUMMARY', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getAccountDetails', error);

      return Promise.reject(error);
    }
  },
  async updateAccountAdditionalHeaderInfo(_, payload) {
    try {
      const response = await RwCustodianService.updateAccountAdditionalInfoLine({
        clUserId: payload.clUserId,
        requestBody: payload.data,
      }).catch((error) => {
        throw error;
      });

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.updateAccountAdditionalHeaderInfo', error);

      return Promise.reject(error);
    }
  },
  async getAccountAdditionalHeaderInfo(_, payload) {
    try {
      const response = await RwCustodianService.getAccountAdditionalInfoLine(payload).catch((error) => {
        throw error;
      });

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getAccountAdditionalHeaderInfo', error);

      return Promise.reject(error);
    }
  },
  /**
   *  This has to dispatch when we need to send an account opening mail to existing account.
   * @param {Object} param0 `Commit` injected by default for committing to store
   * @param {Number} accountRequestId account Request Id
   *
   * @returns {void}
   */
  // eslint-disable-next-line consistent-return
  async sendExistingClientRegistrationMail(_, accountRequestId) {
    try {
      const payload = {
        emailVerificationInfo: {
          accountRequestId,
        },
        workflows: ['notifyAccountCreationPendingToClient'],
      };

      const response = await RwOrchestrateService.postExistingClientAccountOpeningEmail(payload).catch((error) => {
        throw error;
      });

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('client.sendExistingClientRegistrationMail', error);

      return Promise.reject(error);
    }
  },
  async getDefaultDisclosures({commit, state}, payload) {
    try {
      const sdkResponse = await RwCustodianService.getClientDisclosures(payload).catch((error) => {
        throw error;
      });

      const response = {data: {data: sdkResponse}};
      const disclosures = response.data.data;

      commit('SET_CLIENT_ONBOARDING', {
        defaultDisclosure: {
          tradedCompanyInfo: disclosures.publicCompanyHolder
            ? disclosures.publicCompanyHolder
            : state.clientOnBoarding.defaultDisclosure.tradedCompanyInfo,
          firmAssociationInfo: disclosures.exchangeEntity
            ? disclosures.exchangeEntity
            : state.clientOnBoarding.defaultDisclosure.firmAssociationInfo,
          publicOfficialInfo: disclosures.politicalExposureDetail
            ? disclosures.politicalExposureDetail
            : state.clientOnBoarding.defaultDisclosure.publicOfficialInfo,
        },
      });

      return Promise.resolve(disclosures);
    } catch (error) {
      exceptionHandler.handleGenericException('client.getDefaultDisclosures', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line consistent-return
  async updateAccountDetails({commit}, params) {
    try {
      const sdkResponse = await RwClientService.updateAccountDetails(params.accPayload).catch((error) => {
        throw error;
      });

      commit('SET_ACCOUNT_DETAILS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('client.updateAccountDetails', error);

      return Promise.reject(error);
    }
  },
  async getClientRTQHistory({commit}, payload) {
    try {
      const {userId: clUserId, riaId} = payload;
      const options = {clUserId, riaId};
      const response = await RwRiskToleranceService.getRTQQuestionnaireHistory(options).catch((error) => {
        throw error;
      });

      commit('SET_RTQ_HISTORY', response.data);

      return Promise.resolve(response.data);
    } catch (error) {
      return exceptionHandler.handleGenericException('client.getClientRTQHistory', error);
    }
  },
  async sendRTQEmail(_, payload) {
    try {
      const {source: riaUserId, destination: clUserId, emailTemplateName: templateName} = payload;
      const options = {riaUserId, clUserId, templateName};
      const response = await RwOrchestrateService.sendEmailToClient(options).catch((error) => {
        throw error;
      });

      return response;
    } catch (error) {
      return exceptionHandler.handleGenericException('client.sendRTQEmail', error);
    }
  },
  async getClientAccounts(_, payload) {
    try {
      const sdkResponse = await RwClientService.getAllAccountsForClientId({
        clUserId: payload,
      }).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      return exceptionHandler.handleGenericException('client.getClientAccounts', error);
    }
  },
  async deActivateClient({commit, rootState}, payload) {
    try {
      let statusCode = 200;
      let statusMessage = 'Ok';
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);
      const sdkResponse = await RwClientService.deActiveClient(fullPayload).catch((error) => {
        const {microserviceStatusCode, message} = error;

        if (handledResponses.has(microserviceStatusCode)) {
          statusCode = microserviceStatusCode;
          statusMessage = message;
        } else {
          throw error;
        }
      });

      commit('SET_CLIENT_ACCESS', Boolean(payload?.dashboardAccess));

      return Promise.resolve({statusCode, statusMessage, sdkResponse});
    } catch (error) {
      exceptionHandler.handleGenericException('client.deActivateClient', error);

      return Promise.reject(error);
    }
  },
  async deleteClientGoal(_, payload) {
    try {
      const objResponse = await ClientService.deleteClientGoal(payload.goalId, payload.riaId);

      returnNoneApi(objResponse);

      return objResponse.data.data;
    } catch (error) {
      exceptionHandler.handleGenericException('client.deleteClientGoal', error);

      return Promise.reject(error);
    }
  },
  setTempAccountDetails({commit}, payload) {
    commit('SET_TEMP_ACCOUNT_DETAILS', payload);
  },
};

const mutations = {
  SET_TOP_CLIENTS(state, payload) {
    PII.clean(payload);
    state.topClients = payload;
  },
  SET_CLIENTS(state, payload) {
    PII.clean(payload.data);
    state.clients = payload.data;
    state.totalClientCount = payload.count;
  },
  SET_CLIENTS_SUMMARY(state, payload) {
    state.clientsSummary = payload;
  },
  SET_HOUSEHOLDS(state, payload) {
    state.allHouseholds = payload;
  },
  SET_CLIENT_DETAILS(state, payload) {
    const payload_ = payload;

    PII.clean(payload_);

    if (!payload_.segment) {
      delete payload_.segment;
    }

    state.clientDetails = {...state.clientDetails, ...payload_};
  },
  SET_CLIENT_HOUSEHOLD_GOALS(state, payload) {
    state.clientHouseholdGoals = payload;
  },
  SET_CLIENT_DOCUMENTS(state, payload) {
    state.clientDocuments = payload;
  },
  SET_CLIENT_ACCESS(state, payload) {
    state.clientDetails.dashboardAccess = payload;
  },
  SET_CLIENT_TRANSACTIONS(state, payload) {
    state.clientTransactions = payload.data;
  },
  SET_HISTORY_TRANSACTIONS(state, payload) {
    state.clientTransactions = payload.data;
  },
  SET_CLIENT_ADVISOR(state, payload) {
    state.clientDetails.riaUserId = payload.riaUserId;
    state.clientDetails.riaUserName = payload.riaUserName;
    state.clientDetails.riaUserIdBackup = payload.riaUserIdBackup;
    state.clientDetails.backupRiaUserName = payload.backupRiaUserName;
  },
  SET_SEARCHBAR_CLIENTS(state, payload) {
    PII.clean(payload);
    state.searchBarClients = payload;
  },
  SET_SEARCH_CLIENT_PAGINATION(state, payload) {
    state.searchBarTotalCount = payload.count;
  },
  RESET_SEARCHBAR_CLIENTS(state, payload) {
    state.searchBarClients = payload;
    state.searchBarTotalCount = '';
  },
  SET_CLIENT_ONBOARDING(state, payload) {
    if (payload !== null) {
      state.clientOnBoarding = Object.assign(state.clientOnBoarding, payload);

      return;
    }

    state.clientOnBoarding = new ClientOnboarding();
  },
  SET_HOLDINGS(state, payload) {
    state.clientDetails.tickers = payload;
  },
  SET_ACOUNT_HOLDINGS(state, payload) {
    state.clientDetails.tickers = payload;
  },
  SET_ACOUNT_HOLDINGS_TICKERS(state, payload) {
    state.clientDetails.tickers = payload;
  },
  UPDATE_ACOUNT_HOLDING_TICKER() {
    // eslint-disable-next-line no-param-reassign
  },
  UPDATE_ACOUNT_HOLDING_BY_TICKER(state, payload) {
    const {data, index} = payload;
    const [result] = data;

    state.clientDetails.tickers[index.ticker] = result;
  },
  SET_ACCOUNT_TYPES(state, payload) {
    state.accountTypes = payload;
  },
  SET_ACCOUNT_DETAIL_SUMMARY(state, payload) {
    // eslint-disable-next-line prefer-destructuring
    state.clientDetails.accountDetail.summary = payload[0];
  },
  SET_ACCOUNT_DETAILS(state, payload) {
    state.clientDetails.accountDetail.summary.min_cash_value = payload.minCashValue;
    state.clientDetails.accountDetail.summary.distributionAmount = payload.distributionAmount;
    state.clientDetails.accountDetail.summary.distributionId = payload.distributionId;
    state.clientDetails.accountDetail.summary.port_override_id = payload.portOverrideId;
    state.clientDetails.accountDetail.summary.risk_tol_override = payload.riskTolOverride;
    state.clientDetails.accountDetail.summary.risk_tol_override_value = payload.riskTolOverrideValue;
    state.clientDetails.accountDetail.summary.robo_on_off = payload.roboStatus;

    // update account list - (ADV:5753: ...and only for clients with client accounts)
    if (state.clientDetails.clientAccounts && Array.isArray(state.clientDetails.clientAccounts)) {
      state.clientDetails.clientAccounts.some((account) => {
        if (String(account.accountId) === String(payload.accountId)) {
          // eslint-disable-next-line no-param-reassign
          account.roboStatus = payload.roboStatus;

          return true;
        }

        return false;
      });
    }
  },
  SET_GOALS_LIST(state, payload) {
    state.goalsList = payload;
  },
  SET_RTQ_HISTORY(state, payload) {
    state.riskToleranceQuestionnaire = payload;
  },
  SET_TEMP_ACCOUNT_DETAILS(state, payload) {
    const tempAccountDetails = payload.split('_');

    const [repCode, custodianId] = tempAccountDetails;

    state.tempRepCode = repCode;
    state.tempCustodianId = parseInt(custodianId, 10);
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
